import styled from "styled-components";

export const ForgotPWButton = styled.button`
  border: none;
	outline: none;
	background: none;
	text-decoration: underline;
	color: white;
	margin: 10px 0 0 0;
	cursor: pointer;
`;
